<template>
	<div class="register">
		<div class="overlay">
			<div class="area">
				<div class="row justify-content-md-center">
					<div class="col-12 col-md-11 col-xl-9">
						<div class="row flex-row">
							<div class="col-12">
								<div
									class="clearfix btn-close"
									@click="close()"
								>
									<div class="fa fa-chevron-left f-l"></div>
									<div class="text f-l">Go Back</div>
								</div>
							</div>
							<div class="col-12 col-lg-5">
								<!-- <div class="blue-content"  id="blue_content_reg">
                           <div class="row justify-content-center">
                              <div class="col-11 col-lg-10">
                                 <div class="title">
                                    Welcome to <br>
                                    Nexus Insurance
                                 </div>
                                 <div class="text">Register as:</div>
                                 <ul class="benefits">
                                    <li><a href="#"><i class="fa fa-user-tie"></i> Intermediary</a> </li>
                                    <li><a href="#"><i class="fa fa-university"></i> Bank</a> </li>
                                    <li><a href="#"><i class="fa fa-user-tie"></i> Service Provider</a> </li>
                                    <li><a href="#"><i class="fa fa-user-tie"></i> Underwritter</a> </li> 
                                 </ul> 
                              </div> 
                           </div>
                        </div> -->
							</div>
							<div class="col-12 col-lg-7">
								<div
									class="white-content"
									id="white_content_reg"
								>
									<h3>Register</h3>
									<Form
										classBinding="row reg-fields"
										:ref="RegisterModel.forms.register.name"
										:forms="
											RegisterModel.forms.register.forms
										"
										:formData="
											RegisterModel.forms.register.data
										"
									/>
									<div
										class="btn btn-red"
										@click="
											registerUser(
												$refs[
													RegisterModel.forms.register
														.name
												],
											)
										"
									>
										Sign Up
										<div class="lds-ring" v-show="loading">
											<div></div>
											<div></div>
											<div></div>
											<div></div>
										</div>
									</div>
									<div class="login">
										Already have an account?
										<span class="link" @click="logIn()"
											>Log In</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import register from './rsc/stores/register.store';

export default {
	beforeDestroy() {
		this.$store.unregisterModule('register');
	},
	created() {
		utils.registerModule('register', register, this.$store);
	},
	components: {
		Form: () => import('@/libs/clarks/components/form'),
	},
	computed: {
		...mapGetters(['RegisterModel', 'loading']),
	},
	methods: {
		...mapActions(['registerUser', 'logIn']),
		close() {
			Event.$emit('auth:show', { register: false });
		},
	},
	mounted() {
		utils.registerModule('register', register, this.$store);
		this.$store.dispatch('alignBoxToCenter', this);
	},
};
</script>

<style lang="less">
.register {
	.overlay {
		-webkit-backdrop-filter: blur(3px);
		backdrop-filter: blur(3px);
		background-color: #d6d2d2ce;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1200;
		overflow-y: auto;
	}

	.area {
		padding: 30px 0;
		position: relative;
		z-index: 1500;
		left: 0;
		right: 0;
		overflow-x: hidden;

		.btn-close {
			color: #1761fa;
			cursor: pointer;

			.fa {
				width: 30px;
				height: 30px;
				border-radius: 50px;
				font-size: 16px;
				border: solid 2px #1761fa;
				text-align: center;
				padding: 5px 0;
			}
			.text {
				margin: 4px 0 0 10px;
				font-weight: 600;
				font-size: 17px;
			}
		}
		.btn-close:hover {
			.text {
				text-decoration: underline;
			}
		}
		.blue-content {
			position: relative;
			background: #5b626f;
			padding: 10px;
			z-index: 100;
			position: relative;
			border-radius: 8px;
			color: var(--white);
			position: absolute;
			top: calc((100% - 386px) / 2);
			right: -55px;
			width: 100%;
			padding: 40px 0;

			.text {
				margin: 30px 0 10px 0;
				font-size: 18px;
			}
			.benefits {
				list-style-type: none;
				padding: 0;
				margin: 0;
				margin-bottom: 1.5em;

				a {
					color: #c9cbd3;
					&:hover {
						text-decoration: none;
					}
				}

				li i {
					margin: 0 15px 0 0;
					color: #8a91ff;
				}
			}
			.title {
				margin: 35px 0 0 0;
				font-size: 24px;
				font-weight: 600;
			}
		}
		.white-content {
			background: var(--white);
			padding: 40px 20px 40px 75px;
			border-radius: 8px;
			z-index: 50;
			color: var(--text-color) !important;
			text-align: left;

			.btn-red {
				background: var(--ne-red);
				color: var(--white);
				width: 100%;
				margin: 20px 0 10px 0;
			}
			.login {
				text-align: center;
				margin: 0 0 15px 0;

				.link {
					color: var(--ne-blue);
					text-decoration: underline;
				}
				.link:hover {
					font-weight: 600;
				}
			}
		}
		.reg-fields {
			.form-err {
				height: 11px;
			}
			.form-content {
				margin: 5px 0 !important;
			}
			label {
				font-size: 14px;
				color: #7f8fa4;
				font-weight: 400;
				margin: 0;
			}
			input {
				padding: 7px 15px !important;
				height: auto !important;
				font-weight: 600;
				color: #334150;
				font-size: 14px;
			}
		}
	}
}
@media (max-width: 992px) {
	.register {
		.area {
			.blue-content {
				position: static !important;
				border-radius: 8px 8px 0 0;
			}
			.white-content {
				margin-top: -20px;
				border-radius: 0 0 8px 8px;
				padding: 25px;
			}
		}
	}
}
</style>
